module.exports = __webpack_public_path__ + "static/media/mailchimp.ab32dab0.svg";